/**
 * Les étapes de « Compléter mon profil », dans leur ordre : la page les numérote, les ports y
 * cherchent l'étape d'avant et d'après. Sans style, à part : un crochet testé sous Jest les lit sans
 * charger la page.
 */
export const TUTOR_PROFILE_STEPS = [
    "fixedMissions",
    "replaceMissions",
    "availability",
    "specialties",
    "languages",
    "relevantSubjects",
    "classes",
    "billing",
    "personalize",
    "charter",
] as const

export type TutorProfileStep = (typeof TUTOR_PROFILE_STEPS)[number]
